





































































































































































































































import Vue from 'vue'
import displayErrorDefault from '@/assets/utils/displayErrorDefault'
import redirect404 from '@/assets/utils/redirect404'
import axios from 'axios'
import {Component, Ref, Watch} from 'vue-property-decorator'
import {Table} from 'ant-design-vue/types/table/table'
import {debounce} from 'lodash'
import {ReputationUser} from './types'
import isMobile from 'piramis-js-utils/lib/isMobile'
import TableLayout from '@/views/chat/TableLayout.vue'
import UserMainInfo from 'piramis-base-components/src/components/UserMainInfo.vue'
import VuApi from "@/includes/VuApi";
import Icon from 'piramis-base-components/src/components/Icon/Icon.vue'

type TableColumns = 'reputation' | 'rank' | 'xp' | 'ap'

@Component({
  data() {
    return {
      isMobile,
    }
  },
  components: {
    TableLayout,
    UserMainInfo,
    Icon
  }
})
export default class VuReputation extends Vue {
  @Ref('table') Table!: Table

  loading = false

  isMounted = false

  reputationList: Array<ReputationUser> = []

  chat_title: string | null = null

  gentime: string | null = null

  isRankSystemActive = false

  isXpSystemIsEnabled = false

  isReputationSystemIsEnabled = false

  tableTemplate = 0

  searchStr = ''

  searchUsers: Array<ReputationUser> = []

  columnsVisibility: Record<TableColumns, boolean> = {
    reputation: true,
    rank: true,
    xp: true,
    ap: true
  }

  activeUserRecord: ReputationUser | null = null

  isChangeKarmaModalOpen = false

  debounce = debounce(this.onSearch, 1500)

  @Watch('searchStr')
  searchWatcher(value: string): void {
    if (value) {
      this.debounce(value)
    } else {
      this.searchUsers = []
    }
  }

  onSearch(value: string): void {
    this.searchUsers = this.reputationList.filter((user) => {
      if ((user.login && user.login.toLowerCase().includes(value.toLowerCase().trim())) || (user.name && user.name.toLowerCase().includes(value.toLowerCase().trim()))) {
        return user
      }
    })
  }

  get computedReputationList(): Array<ReputationUser> {
    if (!this.searchStr.trim()) {
      return this.reputationList
      // .sort((a, b) => b.xp - a.xp)
    }

    return this.searchUsers
  }

  checkColumnsVisibility(statistics: Array<ReputationUser>) {
    const fieldExists = (record: ReputationUser, field: keyof ReputationUser) => typeof record[field] !== 'undefined' && typeof record[field] === 'number' && record[field] !== 0

    this.columnsVisibility.reputation = statistics.some(r => fieldExists(r, 'karma') || fieldExists(r, 'anti_karma'))
    this.columnsVisibility.rank = statistics.some(r => fieldExists(r, 'rank'))
    this.columnsVisibility.xp = statistics.some(r => fieldExists(r, 'xp'))
    this.columnsVisibility.ap = statistics.some(r => fieldExists(r, 'action_point'))

    const keys = Object.keys(this.columnsVisibility)

    if (keys.every(k => this.columnsVisibility[k as TableColumns])) {
      keys.forEach((key) => {
        this.columnsVisibility[key as TableColumns] = true
      })
    }
  }


  loadReputationData() {
    this.loading = true
    axios.get(`${VuApi.generateApiUrl()}/cabinet/static/reputation/data${this.$route.params.id}.json`)
      .then(res => {
        this.reputationList = res.data.users
          .map((u: ReputationUser) => {
            return {
              ...u,
              xp: u?.xp ?? 0,
              action_point: u?.action_point ?? 0,
              karma: u?.karma ?? 0,
              anti_karma: u?.anti_karma ?? 0,
            }
          })

        this.checkColumnsVisibility(this.reputationList)

        this.chat_title = res.data.chat_title
        this.gentime = res.data.gentime
        this.isRankSystemActive = res.data.user_ranks_by_xp || res.data.user_ranks_by_reputation
        this.isXpSystemIsEnabled = res.data.user_ranks_by_xp
        this.isReputationSystemIsEnabled = res.data.user_ranks_by_reputation
      })
      .finally(() => {
        this.loading = false
      })
      .catch(err => {
        if (!err?.response) {
          displayErrorDefault('Network Error')
        } else {
          const status = err?.response?.status;

          if (status > 400 && status < 500) {
            redirect404();
          } else {
            const errMessage = err.response?.data?.message

            displayErrorDefault(errMessage ?? '')
          }
        }
      })
  }


  mounted() {
    this.isMounted = true;
  }

  created(): void {
    this.$i18n.mergeLocaleMessage('ru', {
      public_reputation_title: 'Репутация',
      reputation_action_points: 'Очки действий',
      reputation_generated_at: 'Дата генерации:',
      reputation_next_rank_xp: 'Следующий ранг <b>«{0}»</b>. До него осталось  <b>{1}</b> очков опыта',
      reputation_next_rank_reputation: 'Следующий ранг <b>«{0}»</b>. До него осталось  <b>{1}</b> очков репутации',
      reputation_next_rank_xp_and_reputation: 'Следующий ранг <b>«{0}»</b>. До него осталось  <b>{1}</b> очков репутации и <b>{2}</b> очков опыта',
      reputation_table_hint_karma_negative: "Отрицательная репутация",
      reputation_table_hint_karma_positive: "Положительная репутация",
    })

    this.$i18n.mergeLocaleMessage('en', {
      public_reputation_title: 'Reputation',
      reputation_action_points: 'Action points',
      reputation_generated_at: 'Generation date:',
      reputation_next_rank_xp: 'The next rank is <b>«{0}»</b>. <b>{1}</b> experience points left before him',
      reputation_next_rank_reputation: 'The next rank is <b>«{0}»</b>. <b>{1}</b> reputation points left before him',
      reputation_next_rank_xp_and_reputation: 'The next rank is <b>«{0}»</b>. Before him there are <b>{1}</b> reputation points and <b>{2}</b> experience points',
      reputation_table_hint_karma_negative: "Negative reputation",
      reputation_table_hint_karma_positive: "Positive reputation",
    })

    this.loadReputationData()
  }

}
